import { Injectable, NgZone } from '@angular/core';
import {Subject, Observable, Subscription} from 'rxjs';
import { environment } from '../environments/environment';
import {AuthenticationService} from "./Login/_services/authentication.service";
import {GetFromLocalStorage} from "../environments/Utility/Utility";

@Injectable({
  providedIn: 'root'
})
export class ReverbService {

  private ws: WebSocket | null = null;

  private reconnectDelay = 1000;
  private readonly MAX_DELAY = 30000;

  private socketId?: string;
  private token?: string;

  private subscriptions: string[] = [];
  private schedules: Subscription = new Subscription();

  private eventsSubject = new Subject<any>();

  public events$: Observable<any> = this.eventsSubject.asObservable();

  constructor(private zone: NgZone, private authSvc: AuthenticationService) {}

  connect(): void {
    const currentUser = GetFromLocalStorage('currentUser');
    if (!environment['reverbKey']) {
      console.error("[SW] APP_KEY non impostata");
      return;
    }
    if (!environment['websocketUrl']) {
      console.error("[SW] websocketUrl non impostata");
      return;
    }
    this.token = currentUser?.access_token;

    const url =
      `${environment['websocketUrl']}/${environment['reverbKey']}` +
      `?protocol=7&client=js&version=8.0.2&flash=false`;
    console.log('connnect to WS url', url);
    this.ws = new WebSocket(url);

    this.ws.onopen = () => {
      console.log('Reverb connected');
      this.ws.send(JSON.stringify({
          type: 'INIT',
          key: environment['reverbKey'],
          token: currentUser?.access_token

      }));
    };

    this.ws.onmessage = (event) => {

      const message = JSON.parse(event.data);

      this.zone.run(() => {

        switch (message.event) {

          case 'pusher:connection_established':

            this.socketId =
              JSON.parse(message.data).socket_id;

            this.resubscribe();

            break;

          case 'pusher_internal:subscription_succeeded':

            this.eventsSubject.next({
              type: 'CONNECTED'
            });
            console.log('WS subscribed')

            break;

          case 'pusher:ping':

            this.ws?.send(JSON.stringify({
              event: 'pusher:pong',
              data: {}
            }));

            break;

          default:
            console.log("register new event" )
            this.eventsSubject.next({
              type: 'EVENT',
              event: message.event,
              channel: message.channel,
              data: JSON.parse(message.data)
            });

        }

      });

    };

    this.ws.onclose = (close) => {
      console.log('WS closed', close);
      if(this.token)
      this.scheduleReconnect();
    };

    this.ws.onerror = (e) => {
      this.ws?.close();
      console.log('WS error', e);
    };
  }

  disconnect(): void {
    if (this.ws) {
      this.token = null;
      this.ws.close();
      this.ws = null;
      this.subscriptions = [];

      this.schedules.unsubscribe();
      console.log('WS: disconnect');
      console.log('subscriptions: ', this.subscriptions)
    }
  }

  private scheduleReconnect(): void {
    this.schedules.add(()=>
    setTimeout(() => {

      // this.reconnectDelay = Math.min(
      //   this.reconnectDelay * 2,
      //   this.MAX_DELAY
      // );
      this.connect();

    }, this.reconnectDelay));

  }

  private resubscribe(): void {
    console.log('WS: resubscribe', this.ws, this.subscriptions);

    this.subscriptions.forEach(channel => {
      this.subscribePrivate(channel, this.token);
    });

  }

  async subscribeToNotifyChannel(){
    var currentUser = GetFromLocalStorage('currentUser');
    setTimeout(async ()=>{
      if(!currentUser){
        setTimeout(async () => await this.subscribeToNotifyChannel(),300);
        return;
      }else{
        return await this.subscribePrivate(`private-notify.${currentUser['negozioId'] ?? currentUser.id }`, currentUser.access_token)
      }    },2000)
    if(!currentUser){
      setTimeout(async () => await this.subscribeToNotifyChannel(),300);
      return;
    }else{
      return await this.subscribePrivate(`private-notify.${currentUser['negozioId'] ?? currentUser.id }`, currentUser.access_token)
    }

  }


  async subscribePrivate(channel: string,token ): Promise<void> {

    if (!this.ws ||
      this.ws.readyState !== WebSocket.OPEN ||
      !this.socketId) {

      if (!this.subscriptions.includes(channel)) {
        this.subscriptions.push(channel);
      }

      return;
    }

    if (!this.subscriptions.includes(channel)) {
      this.subscriptions.push(channel);
    }

    const response = await fetch(
      environment['broadcastAuthUrl'],
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${ token}`
        },
        body: JSON.stringify({
          channel_name: channel,
          socket_id: this.socketId
        })
      }
    );

    if (!response.ok) {

      const status = response.status;

      let errorType = "unknown_error";
      let message = "Errore sconosciuto durante l'autenticazione";

      if (status === 401) {
        errorType = "unauthorized";
        message = "Token non valido o scaduto";
      } else if (status === 403) {
        errorType = "forbidden";
        message = "Accesso al canale negato";
      } else if (status === 419) {
        errorType = "csrf_expired";
        message = "Sessione scaduta";
      } else if (status >= 500) {
        errorType = "server_error";
        message = "Errore interno del server";
      }
      throw new Error(`[SW] Auth error ${status}: ${message}`);
    }

    const auth = await response.json();

    this.ws.send(JSON.stringify({
      event: 'pusher:subscribe',
      data: {
        auth: auth.auth,
        channel
      }
    }));
  }

}
